import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M12.938 18.5C5.763 18.5 1.67 13.62 1.5 5.5h3.594c.118 5.96 2.768 8.485 4.866 9.005V5.5h3.384v5.14c2.073-.221 4.25-2.563 4.985-5.14h3.384c-.564 3.175-2.925 5.518-4.604 6.48 1.679.781 4.368 2.824 5.391 6.52h-3.725c-.8-2.472-2.794-4.385-5.43-4.646V18.5z"
    }, null, -1)
  ])))
}
export default { render: render }